import { makeStyles } from 'tss-react/mui';

const name = 'BalanceStatusIcon';

export const useBalanceStatusIconStyles = makeStyles({ name })(theme => ({
  error: {
    '&&': {
      marginRight: theme.spacing(1),

      color: theme.palette.error.main,
    },
  },
  warning: {
    '&&': {
      marginRight: theme.spacing(1),

      color: theme.palette.warning.main,
    },
  },
}));
